import { render, staticRenderFns } from "./DetailsConstraints.vue?vue&type=template&id=317ce745&scoped=true&"
import script from "./DetailsConstraints.vue?vue&type=script&lang=js&"
export * from "./DetailsConstraints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317ce745",
  null
  
)

export default component.exports